import { SearchInput } from "@finanedi.es/storybook"
import { GetUsuarioByFiltersParamsProps } from "api/Usuario.service"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import { ToggleSwitch } from "common/components/Toogle"
import { Skeleton } from "primereact/skeleton"
import { Dispatch, SetStateAction, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export default ({
  isLoading,
  sortingCriteria,
  skipCount,
  maxResultCount,
  totalCount,
  serviceQuery,
  resetPagination,
}: {
  isLoading: boolean
  sortingCriteria?: SortingCriteria
  skipCount?: GetUsuarioByFiltersParamsProps["SkipCount"]
  maxResultCount?: GetUsuarioByFiltersParamsProps["MaxResultCount"]
  totalCount?: number
  serviceQuery: Dispatch<SetStateAction<GetUsuarioByFiltersParamsProps>>
  resetPagination?: () => void
}) => {
  const { t } = useTranslation()
  const [soloResponsable, setSoloResponsable] = useState<boolean>(false)
  const [nombre, setNombre] =
    useState<GetUsuarioByFiltersParamsProps["Nombre"]>()

  const queryFixer = (
    queryParams: GetUsuarioByFiltersParamsProps
  ): GetUsuarioByFiltersParamsProps => {
    const remesaParams = {
      DepartamentoId: queryParams.DepartamentoId,
      Nombre: queryParams.Nombre,
      SoloResponsable: queryParams.SoloResponsable,
      MaxResultCount: queryParams.MaxResultCount,
      SkipCount: queryParams.SkipCount,
      SortingCriteria:
        queryParams.SortingCriteria?.property &&
        queryParams.SortingCriteria?.sort
          ? `${queryParams.SortingCriteria.property} ${queryParams.SortingCriteria.sort}`
          : "CreationTime DESC",
    }
    const fixedQueryParams = Object.fromEntries(
      Object.entries(remesaParams).filter(
        ([_key, value]) => value || value === 0 // eslint-disable-line @typescript-eslint/no-unused-vars
      )
    )
    return fixedQueryParams
  }
  const query = {
    Nombre: nombre,
    SoloResponsable: soloResponsable,
    SortingCriteria: sortingCriteria,
    SkipCount: skipCount,
    MaxResultCount: maxResultCount,
  }
  const handleQuery = () => {
    serviceQuery(queryFixer(query))
  }

  useEffect(() => {
    resetPagination?.()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nombre])

  useEffect(() => {
    handleQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    nombre,
    soloResponsable,
    skipCount,
    maxResultCount,
    sortingCriteria?.property,
    sortingCriteria?.sort,
  ])

  return (
    <>
      <div className='!tw-px-6 tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-items-center tw-pb-4 tw-pt-6 tw-shadow-3xl tw-rounded-t-xl mb-1 tw-bg-white'>
        <p className='tw-whitespace-nowrap tw-text-xl tw-text-text tw-my-auto tw-flex tw-flex-row tw-gap-3 tw-items-center'>
          {t("gestionUsuarios.users.title")}{" "}
          {isLoading ? (
            <Skeleton className='!tw-h-5 !tw-w-8 !tw-mx-1' />
          ) : (
            <span>{`(${totalCount})`}</span>
          )}
        </p>
        <div className='tw-flex tw-w-full tw-justify-center lg:tw-justify-end'>
          <div className='!tw-w-fit tw-flex tw-items-center !tw-flex-row tw-justify-end tw-flex-wrap'>
            <div className='tw-grid tw-gap-3 sm:tw-flex sm:tw-flex-row sm:tw-grid-cols-1 tw-items-center tw-w-fit'>
              <span className='tw-text-sm'>
                {t("gestionUsuarios.users.labelResponsible")}
              </span>
              <ToggleSwitch
                defaultState={soloResponsable}
                id='switch-solo-responsable'
                onChangeHandler={setSoloResponsable}
              />
              <SearchInput
                placeholder={`${t(
                  "gestionUsuarios.users.placeholderSearcUser"
                )}`}
                onChange={(ev: string) => {
                  resetPagination?.()
                  setNombre(ev)
                }}
                inputValue={nombre}
                className='tw-h-10 tw-w-full sm:tw-w-72'
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
